import { h, Component } from 'preact';
import { styled } from 'goober';

type TimerProps = {
  resendOTP: any,
  additionalText?: string,
  resendText?: string,
};

type TimerState = {
  resendCounter: number,
};

const ResendOtpContainer = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  .resendOtp {
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    width: fit-content;
    margin: auto;
    color: #227cdc;
    text-decoration: underline;
  }
`;

const TimerContainer = styled('div')`
  width: 100%;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  color: #636363;
  .timer {
    font-weight: 500;
    display: inline-block;
    width: 45px;
    text-align: left;
  }
`;

class ResendTimer extends Component<TimerProps, TimerState> {
  state: TimerState = {
    resendCounter: 30,
  };
  intervalId: any;
  componentDidMount() {
    this.initTimer();
  }
  componentWillUnmount() {
    clearInterval(this.intervalId);
  }
  initTimer = () => {
    this.intervalId = setInterval(this.timer, 1000);
  };

  timer = () => {
    this.setState(
      ({ resendCounter }) => ({
        resendCounter: resendCounter - 1,
      }),
      () => {
        if (this.state.resendCounter === 0) {
          clearInterval(this.intervalId);
        }
      },
    );
  };
  resendOtp = () => {
    const { resendOTP } = this.props;
    resendOTP();
    this.initTimer();
  };
  render() {
    const { resendCounter } = this.state || {};
    const { additionalText, resendText } = this.props;
    return (
      <div>
        {resendCounter === 0 ? (
          <ResendOtpContainer>
            <div>{resendText ? resendText : ''} </div>
            <div
              className='resendOtp'
              onClick={() =>
                this.setState({ resendCounter: 30 }, () => this.resendOtp())
              }>
              Resend Share Code
            </div>
          </ResendOtpContainer>
        ) : (
          <TimerContainer>
            {additionalText}{' '}
            <div className='timer'>
              00:{resendCounter < 10 ? `0${resendCounter}` : resendCounter}
            </div>
          </TimerContainer>
        )}
      </div>
    );
  }
}

export default ResendTimer;



// WEBPACK FOOTER //
// ./components/salesApp/ResendTimer.js